/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Typography, Grid } from '@mui/material';
import { AlertError, ButtonWarning, CallBox, CallButton, CallDetails, CallHeader, CallStateError } from './call-styles';
import { Close, ErrorOutline, Phone } from '@mui/icons-material';
import CallWarningActions from './call-warning-actions';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';
import { useCallIdentity } from '../../hooks/use-call-identity';
import { usePhone } from '../../hooks/use-phone';
import React from 'react';
import { formatUSPhoneNumber } from '../../utils/formatter';

export default function CallErrorNotCreated() {
    const { phoneNumber, hideWarning, isLoading } = usePhoneWarnings();
    const { contactNames } = useCallIdentity({ phoneNumber: phoneNumber as string });

    const { createDevice } = usePhone();

    return (
        <CallBox data-testid='call-error-not-created'>
            <CallHeader>
                <Grid container>
                    <Grid item xs={6} zeroMinWidth>
                        <CallStateError>ERROR</CallStateError>
                        <Typography variant='h6' noWrap>
                            {contactNames ? contactNames : ''}
                        </Typography>
                        <Typography variant='body2'>{formatUSPhoneNumber(phoneNumber!)}</Typography>
                        <Typography variant='body2'>--:--</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <CallButton disabled sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}>
                            <Phone />
                        </CallButton>
                        <CallButton onClick={hideWarning}>
                            <Close sx={{ fontSize: 32 }} />
                        </CallButton>
                    </Grid>
                </Grid>
                <AlertError icon={<ErrorOutline style={{ fontSize: 22, color: '#E31B0C' }} />} severity='error'>
                    You are not currently set up to place and receive calls in RevenueWell.
                    <ButtonWarning
                        variant='contained'
                        loading={isLoading}
                        loadingPosition='end'
                        onClick={() => {
                            createDevice();
                        }}
                    >
                        {isLoading ? 'Setting Up' : 'Start Using Phone'}
                    </ButtonWarning>
                </AlertError>
            </CallHeader>
            <CallDetails>
                <CallWarningActions phoneNumber={phoneNumber!} />
            </CallDetails>
        </CallBox>
    );
}
